<template>
  <div>
    <app-cells position="between">
      <div class="date-picker-wrapper">
        <VueCtkDateTimePicker
          id="date_picker_balance"
          class="custom-date-time-picker custom-date-time-picker--range"
          v-model="filter_dates"
          :custom-shortcuts="custom_shortcuts"
          shortcut="lastHalfYear"
          @is-hidden="onIsHiddenPicker"
          format="YYYY-MM-DD"
          formatted="ll"
          label="Select dates"
          color="#77b017"
          button-color="#77b017"
          overlay
          no-header
          no-label
          locale="en"
          range
          noClearButton
        />
        <div v-if="date_picker_error" class="date-picker-wrapper__error">Choose an end date</div>
      </div>
      <app-button ref="download_all" @click.native="onDownloadAll">Download all</app-button>
    </app-cells>
    <app-spinner v-if="!is_loaded" />
    <template v-else>
      <app-cells>
        <h2 class="title">Source</h2>
        <span class="status-tag" :style="{ 'backgroundColor': '#77b017' }">{{ source_data.exist }}</span>
        <span class="status-tag" :style="{ 'backgroundColor': '#e85c20' }">{{ source_data.missing }}</span>
        <app-filters
          v-model="filter_allocate"
          :filters="filter_allocate_options"
          name="filterAllocate"
          @change="fetchSource"
        />
      </app-cells>
      <v-client-table
        :data="table_source.items"
        :columns="table_source.columns"
        :options="table_source.options"
        class="table-default"
      >
        <template #h__name><div class="table-default__left">Name</div></template>
        <template #index="{ row, index }">{{ index }}</template>
        <template #name="{ row }"><div class="table-default__left">{{ row[0] }} {{ row[1].ppc_ratio ? `(${row[1].ppc_ratio}%)` : '' }}</div></template>
        <template #count="{ row }">{{ row[1].count }} ({{ row[1].count_percent }}%)</template>
        <template #conversion="{ row }">{{ row[1].conversion }}%</template>
        <template #confirmed="{ row }">{{ row[1].confirmed }}</template>
        <template #cost_per_lead="{ row }">{{ row[1].cost_per_lead.toLocaleString() }} $</template>
        <template #expenses="{ row }">{{ row[1].expenses.toLocaleString() }} $</template>
        <template #commission="{ row }">{{ row[1].commission.toLocaleString() }} $</template>
      </v-client-table>
      <app-cells>
        <h2 class="title">Countries</h2>
        <span class="status-tag" :style="{ 'backgroundColor': '#77b017' }">{{ countries_data.exist }}</span>
        <span class="status-tag" :style="{ 'backgroundColor': '#e85c20' }">{{ countries_data.missing }}</span>
        <app-select
          @input="fetchRequestCountries"
          v-model="country_source_filter"
          :options="source_options"
          :reduce="item => item.code"
          placeholder="Advertising source"
          class="select--200"
        />
      </app-cells>
      <v-client-table
        :data="table_countries.items"
        :columns="table_countries.columns"
        :options="table_countries.options"
        class="table-default"
      >
        <template #h__country><div class="table-default__left">Country</div></template>
        <template #index="{ row, index }">{{ index }}</template>
        <template #country="{ row }">
          <div class="table-default__left table-default__controls">
            <span :class="`fflag ff-md fflag-${row[1].country_code || 'empty'}`"></span>
            {{ row[0] }}
          </div>
        </template>
        <template #count="{ row }">{{ row[1].count }}</template>
        <template #conversion="{ row }">{{ row[1].conversion }}%</template>
        <template #confirmed="{ row }">{{ row[1].confirmed }}</template>
        <template #amount="{ row }">{{ row[1].amount.toLocaleString() }}$</template>
        <template #commission="{ row }">{{ row[1].commission.toLocaleString() }}$</template>
      </v-client-table>
      <app-cells><h2 class="title">Expenses</h2></app-cells>
      <highcharts :options="graph_expenses_options" />
      <app-cells>
        <h2 class="title">Campaign</h2>
        <span class="status-tag" :style="{ 'backgroundColor': '#77b017' }">{{ campaign_data.exist }}</span>
        <span class="status-tag" :style="{ 'backgroundColor': '#e85c20' }">{{ campaign_data.missing }}</span>
        <app-input
          @input.native="onCampaignSearch"
          v-model="search"
          class="input--200"
          type="search"
          placeholder="Search"
          name="search"
        />
        <app-select
          @input="fetchCampaign"
          v-model="source"
          :options="source_options"
          :reduce="item => item.code"
          placeholder="Source"
          class="select--200"
        />
      </app-cells>
      <v-client-table
        :data="table_campaign.items"
        :columns="table_campaign.columns"
        :options="table_campaign.options"
        class="table-default"
      >
        <template #h__name><div class="table-default__left">Name</div></template>
        <template #index="{ row, index }">{{ index }}</template>
        <template #name="{ row }"><div class="table-default__left">{{ row[0] }}</div></template>
        <template #count="{ row }">{{ row[1].count }}</template>
        <template #lead="{ row }">{{ row[1].lead }}</template>
        <template #lost="{ row }">{{ row[1].lost }}</template>
        <template #spam="{ row }">{{ row[1].spam }}</template>
        <template #double_request="{ row }">{{ row[1].double_request }}</template>
        <template #no_response="{ row }">{{ row[1].no_response }}</template>
        <template #pre_confirmed="{ row }">{{ row[1].pre_confirmed }}</template>
        <template #confirmed="{ row }">{{ row[1].confirmed }}</template>
        <template #conversion="{ row }">{{ row[1].conversion }}%</template>
        <template #amount="{ row }">{{ row[1].amount.toLocaleString() }} $</template>
        <template #commission="{ row }">{{ row[1].commission.toLocaleString() }} $</template>
      </v-client-table>
      <app-cells>
        <h2 class="title">Content</h2>
        <span class="status-tag" :style="{ 'backgroundColor': '#77b017' }">{{ campaign_data.exist }}</span>
        <span class="status-tag" :style="{ 'backgroundColor': '#e85c20' }">{{ campaign_data.missing }}</span>
        <app-input
          @input.native="onContentSearch"
          v-model="content_search"
          class="input--200"
          type="search"
          placeholder="Search"
          name="search"
        />
        <app-select
          @input="onInputSourceFilter"
          v-model="source_filter"
          :options="source_options"
          placeholder="Source"
          class="select--200"
        />
        <app-select
          v-if="campaign_options_filter.length"
          @input="fetchContent"
          v-model="campaign_filter"
          :options="campaign_options_filter"
          :reduce="item => item.id"
          placeholder="Campaign"
          class="select--300"
        />
      </app-cells>
      <v-client-table
        :data="table_content.items"
        :columns="table_content.columns"
        :options="table_content.options"
        class="table-default"
      >
        <template #h__name><div class="table-default__left">Name</div></template>
        <template #index="{ row, index }">{{ index }}</template>
        <template #name="{ row }"><div class="table-default__left">{{ row[0] }}</div></template>
        <template #count="{ row }">{{ row[1].count }}</template>
        <template #lead="{ row }">{{ row[1].lead }}</template>
        <template #lost="{ row }">{{ row[1].lost }}</template>
        <template #spam="{ row }">{{ row[1].spam }}</template>
        <template #double_request="{ row }">{{ row[1].double_request }}</template>
        <template #no_response="{ row }">{{ row[1].no_response }}</template>
        <template #pre_confirmed="{ row }">{{ row[1].pre_confirmed }}</template>
        <template #confirmed="{ row }">{{ row[1].confirmed }}</template>
        <template #conversion="{ row }">{{ row[1].conversion }}%</template>
        <template #amount="{ row }">{{ row[1].amount.toLocaleString() }} $</template>
        <template #commission="{ row }">{{ row[1].commission.toLocaleString() }} $</template>
      </v-client-table>
      <app-cells>
        <h2 class="title">Term</h2>
        <span class="status-tag" :style="{ 'backgroundColor': '#77b017' }">{{ term_data.exist }}</span>
        <span class="status-tag" :style="{ 'backgroundColor': '#e85c20' }">{{ term_data.missing }}</span>
        <app-input
          @input.native="onTermSearch"
          v-model="term_search"
          class="input--200"
          type="search"
          placeholder="Search"
          name="search"
        />
        <app-select
          @input="onInputSourceTermFilter"
          v-model="source_term_filter"
          :options="source_options"
          placeholder="Source"
          class="select--200"
        />
        <app-select
          v-if="campaign_term_options_filter.length"
          @input="fetchTerm"
          v-model="campaign_term_filter"
          :options="campaign_term_options_filter"
          :reduce="item => item.id"
          placeholder="Campaign"
          class="select--300"
        />
      </app-cells>
      <v-client-table
        :data="table_term.items"
        :columns="table_term.columns"
        :options="table_term.options"
        class="table-default"
      >
        <template #h__name><div class="table-default__left">Name</div></template>
        <template #index="{ row, index }">{{ index }}</template>
        <template #name="{ row }"><div class="table-default__left">{{ row[0] }}</div></template>
        <template #count="{ row }">{{ row[1].count }}</template>
        <template #lead="{ row }">{{ row[1].lead }}</template>
        <template #lost="{ row }">{{ row[1].lost }}</template>
        <template #spam="{ row }">{{ row[1].spam }}</template>
        <template #double_request="{ row }">{{ row[1].double_request }}</template>
        <template #no_response="{ row }">{{ row[1].no_response }}</template>
        <template #pre_confirmed="{ row }">{{ row[1].pre_confirmed }}</template>
        <template #confirmed="{ row }">{{ row[1].confirmed }}</template>
        <template #conversion="{ row }">{{ row[1].conversion }}%</template>
        <template #amount="{ row }">{{ row[1].amount.toLocaleString() }} $</template>
        <template #commission="{ row }">{{ row[1].commission.toLocaleString() }} $</template>
      </v-client-table>
      <app-cells><h2 class="title">Leads</h2></app-cells>
      <highcharts :options="graph_count_options" />
      <app-cells><h2 class="title">PPC Ratio</h2></app-cells>
      <highcharts :options="graph_ratio_options" />
      <app-cells><h2 class="title">Cost per Lead</h2></app-cells>
      <highcharts :options="graph_price_options" />
      <app-cells><h2 class="title">Price per sales</h2></app-cells>
      <highcharts :options="graph_price_sales_options" />
    </template>
  </div>
</template>

<script>
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'
import {
  getClientsAnalyticsAdv,
  getLeadsAdvSources,
  getLeadsAnalyticsAdvertising,
  getLeadsAnalyticsCampaign,
  getLeadsAnalyticsContent,
  getLeadsAnalyticsRequestsAdv,
  getLeadsAnalyticsRequestsCountries,
  getLeadsAnalyticsRequestsTerm,
} from '@/http'
import debounce from 'lodash/debounce'
import moment from 'moment/moment'
import { Chart as highcharts } from 'highcharts-vue'

export default {
  name: 'CRMAnalyticsAdvertising',
  components: {highcharts, VueCtkDateTimePicker },
  data() {
    return {
      is_loaded: false,
      filter_dates: null,
      date_picker_error: false,
      custom_shortcuts: [
        { key: 'last7Days', label: 'Last 7 days', value: 7 },
        { key: 'last30Days', label: 'Last 30 days', value: 30 },
        { key: 'last60Days', label: 'Last 60 days', value: 60 },
        { key: 'last90Days', label: 'Last 90 days', value: 90 },
        { key: 'last180Days', label: 'Last 180 days', value: 180 },
        { key: 'thisYear', label: 'This year', value: 'year' },
        { key: 'lastYear', label: 'Last year', value: '-year' },
        { key: 'lastHalfYear', label: 'Last half of year', value: () => ({ start: new moment().subtract(5, 'months').startOf('month'), end: new moment().endOf('month') }) },
      ],
      filter_allocate: '0',
      filter_allocate_options: [
        { value: '0', label: 'Not allocate N/A' },
        { value: '1', label: 'Allocate N/A' },
      ],
      table_source: {
        items: [],
        columns: ['index', 'name', 'count', 'conversion', 'confirmed', 'cost_per_lead', 'expenses', 'commission'],
        options: {
          headings: {
            'index': '#',
            'name': 'Name',
            'count': 'Count',
            'conversion': 'Conversion',
            'confirmed': 'Confirmed',
            'cost_per_lead': 'Cost per lead',
            'expenses': 'Expenses',
            'commission': 'Commission',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 100,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      table_campaign: {
        items: [],
        columns: ['index', 'name', 'count', 'lead', 'lost', 'spam', 'double_request', 'no_response', 'pre_confirmed', 'confirmed', 'conversion', 'amount', 'commission'],
        options: {
          headings: {
            'index': '#',
            'name': 'Name',
            'count': 'Count',
            'lead': 'Lead',
            'lost': 'Lost',
            'spam': 'Spam',
            'double_request': 'DR',
            'no_response': 'NR',
            'pre_confirmed': 'Pre confirmed',
            'confirmed': 'Confirmed',
            'conversion': 'Conversion',
            'amount': 'Total sales',
            'commission': 'Commission',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 100,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      table_content: {
        items: [],
        columns: ['index', 'name', 'count', 'lead', 'lost', 'spam', 'double_request', 'no_response', 'pre_confirmed', 'confirmed', 'conversion', 'amount', 'commission'],
        options: {
          headings: {
            'index': '#',
            'name': 'Name',
            'count': 'Count',
            'lead': 'Lead',
            'lost': 'Lost',
            'spam': 'Spam',
            'double_request': 'DR',
            'no_response': 'NR',
            'pre_confirmed': 'Pre confirmed',
            'confirmed': 'Confirmed',
            'conversion': 'Conversion',
            'amount': 'Total sales',
            'commission': 'Commission',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 100,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      table_term: {
        items: [],
        columns: ['index', 'name', 'count', 'lead', 'lost', 'spam', 'double_request', 'no_response', 'pre_confirmed', 'confirmed', 'conversion', 'amount', 'commission'],
        options: {
          headings: {
            'index': '#',
            'name': 'Name',
            'count': 'Count',
            'lead': 'Lead',
            'lost': 'Lost',
            'spam': 'Spam',
            'double_request': 'DR',
            'no_response': 'NR',
            'pre_confirmed': 'Pre confirmed',
            'confirmed': 'Confirmed',
            'conversion': 'Conversion',
            'amount': 'Total sales',
            'commission': 'Commission',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 100,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      term_data: {},
      source_data: {},
      campaign_data: {},
      content_data: {},
      source: null,
      country_source_filter: null,
      source_options: [],
      campaign_options_filter: [],
      search: '',
      content_search: '',
      term_search: '',
      source_filter: null,
      campaign_filter: null,
      source_term_filter: null,
      campaign_term_filter: null,
      campaign_term_options_filter: [],
      graph_expenses_options: {
        accessibility: {
          enabled: false,
        },
        CSSObject: {
          fontFamily: 'regular',
          fontSize: '6.2em',
        },
        chart: {
          type: 'spline'
        },
        title: {
          text: ''
        },
        xAxis: {
          categories: [],
        },
        yAxis: {
          title: {
            text: ''
          }
        },
        plotOptions: {
          series: {
            dataLabels: {
              enabled: true,
            }
          }
        },
        series: []
      },
      graph_count_options: {
        accessibility: {
          enabled: false,
        },
        CSSObject: {
          fontFamily: 'regular',
          fontSize: '6.2em',
        },
        chart: {
          type: 'spline'
        },
        title: {
          text: ''
        },
        xAxis: {
          categories: [],
        },
        yAxis: {
          title: {
            text: ''
          }
        },
        plotOptions: {
          series: {
            dataLabels: {
              enabled: true,
            }
          }
        },
        series: []
      },
      graph_ratio_options: {
        accessibility: {
          enabled: false,
        },
        CSSObject: {
          fontFamily: 'regular',
          fontSize: '6.2em',
        },
        chart: {
          type: 'spline'
        },
        title: {
          text: ''
        },
        xAxis: {
          categories: [],
        },
        yAxis: {
          title: {
            text: ''
          }
        },
        plotOptions: {
          series: {
            dataLabels: {
              enabled: true,
            }
          }
        },
        series: []
      },
      graph_price_options: {
        accessibility: {
          enabled: false,
        },
        CSSObject: {
          fontFamily: 'regular',
          fontSize: '6.2em',
        },
        chart: {
          type: 'spline'
        },
        title: {
          text: ''
        },
        xAxis: {
          categories: [],
        },
        yAxis: {
          title: {
            text: ''
          }
        },
        plotOptions: {
          series: {
            dataLabels: {
              enabled: true,
            }
          }
        },
        series: []
      },
      graph_price_sales_options: {
        accessibility: {
          enabled: false,
        },
        CSSObject: {
          fontFamily: 'regular',
          fontSize: '6.2em',
        },
        chart: {
          type: 'spline'
        },
        title: {
          text: ''
        },
        xAxis: {
          categories: [],
        },
        yAxis: {
          title: {
            text: ''
          }
        },
        plotOptions: {
          series: {
            dataLabels: {
              enabled: true,
            }
          }
        },
        series: []
      },
      countries_data: {},
      table_countries: {
        items: [],
        columns: [
          'index',
          'country',
          'count',
          'conversion',
          'confirmed',
          'amount',
          'commission'
        ],
        options: {
          headings: {
            'index': '#',
            'country': 'Country',
            'count': 'Count',
            'conversion': 'Conversion',
            'confirmed': 'Confirmed',
            'amount': 'Total sales',
            'commission': 'Commission',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 1000,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
    }
  },
  mounted() {
    Promise.all([
      this.fetchSource(),
      this.fetchCampaign(),
      this.fetchContent(),
      this.fetchGraph(),
      this.fetchRequestCountries(),
      this.fetchTerm()
    ]).then(() => {
      this.is_loaded = true
    })
    getLeadsAdvSources().then(res => { this.source_options = res.data })
  },
  methods: {
    onDownloadAll() {
      this.$refs.download_all.preload = true
      getClientsAnalyticsAdv()
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'Clients analytics.xlsx')
          document.body.appendChild(link)
          link.click()
          URL.revokeObjectURL(url)
          this.$refs.download_all.preload = false
        })
    },
    fetchTables() {
      this.fetchSource()
      this.fetchCampaign()
      this.fetchContent()
      this.fetchRequestCountries()
      this.fetchTerm()
    },
    onInputSourceFilter(e) {
      this.campaign_filter = null
      this.campaign_options_filter = e ? e.campaigns : []
      this.fetchContent()
    },
    onInputSourceTermFilter(e) {
      this.campaign_term_filter = null
      this.campaign_term_options_filter = e ? e.campaigns : []
      this.fetchTerm()
    },
    onIsHiddenPicker() {
      if (this.filter_dates?.start && this.filter_dates?.end) {
        this.date_picker_error = false
        this.is_loaded = false
        this.fetchTables()
        this.fetchGraph()
      } else this.date_picker_error = true
    },
    async fetchRequestCountries() {
      const response = await getLeadsAnalyticsRequestsCountries({
        from_date: this.filter_dates.start,
        to_date: this.filter_dates.end,
        adv_source: this.country_source_filter,
      })
      this.table_countries.items = Object.entries(response.data.countries)
      this.countries_data = { exist: response.data.exist, missing: response.data.missing }
    },
    async fetchGraph() {
      const response = await getLeadsAnalyticsRequestsAdv({from_date: this.filter_dates.start, to_date: this.filter_dates.end})
      this.graph_expenses_options.xAxis.categories = response.data.expenses.categories
      this.graph_expenses_options.series = response.data.expenses.series
      this.graph_count_options.xAxis.categories = response.data.counts.categories
      this.graph_count_options.series = response.data.counts.series
      this.graph_ratio_options.xAxis.categories = response.data.counts_percent.categories
      this.graph_ratio_options.series = response.data.counts_percent.series
      this.graph_price_options.xAxis.categories = response.data.price.categories
      this.graph_price_options.series = response.data.price.series
      this.graph_price_sales_options.xAxis.categories = response.data.price_per_sales.categories
      this.graph_price_sales_options.series = response.data.price_per_sales.series
      this.is_loaded = true
    },
    async fetchTerm() {
      const response = await getLeadsAnalyticsRequestsTerm({
        from_date: this.filter_dates.start,
        to_date: this.filter_dates.end,
        search: this.term_search,
        source: this.term_search ? '' : this.source_term_filter?.code,
        campaign: this.term_search ? '' : this.campaign_term_filter
      })
      this.table_term.items = Object.entries(response.data.instances)
      this.term_data = { exist: response.data.exist, missing: response.data.missing }
    },
    async fetchSource() {
      const response = await getLeadsAnalyticsAdvertising({
        from_date: this.filter_dates.start,
        to_date: this.filter_dates.end,
        allocate_na: this.filter_allocate !== '0'
      })
      this.table_source.items = Object.entries(response.data.instances)
      this.source_data = { exist: response.data.exist, missing: response.data.missing }
    },
    async fetchCampaign() {
      const response = await getLeadsAnalyticsCampaign({
        from_date: this.filter_dates.start,
        to_date: this.filter_dates.end,
        source: this.search ? '' : this.source,
        search: this.search
      })
      this.table_campaign.items = Object.entries(response.data.instances)
      this.campaign_data = { exist: response.data.exist, missing: response.data.missing }
    },
    async fetchContent() {
      const response = await getLeadsAnalyticsContent({
        from_date: this.filter_dates.start,
        to_date: this.filter_dates.end,
        search: this.content_search,
        source: this.content_search ? '' : this.source_filter?.code,
        campaign: this.content_search ? '' : this.campaign_filter
      })
      this.table_content.items = Object.entries(response.data.instances)
      this.content_data = { exist: response.data.exist, missing: response.data.missing }
    },
    onCampaignSearch() {
      this.searchCampaign(this)
    },
    searchCampaign: debounce(vm => {
      vm.fetchCampaign()
    }, 350),
    onContentSearch() {
      this.searchContent(this)
    },
    searchContent: debounce(vm => {
      vm.fetchContent()
    }, 350),
    onTermSearch() {
      this.searchTerm(this)
    },
    searchTerm: debounce(vm => {
      vm.fetchTerm()
    }, 350),
  }
}
</script>

<style lang="sass" scoped>
.date-picker-wrapper
  position: relative

.date-picker-wrapper__error
  position: absolute
  bottom: -18px
  color: $color-error
  font-size: 12px
</style>
